//E:\SAUDIDUNES11\frontend\src\pages\LoginPage.js
import styled from "styled-components";
import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: linear-gradient(
      rgba(255, 255, 255, 0.5),
      rgba(255, 255, 255, 0.5)
    );
  background-size: cover;
  display: flex;
  align-items: center;
  justify-content: center;

  @media only screen and (max-width: 768px) {
    padding: 0 15px;
  }
`;

const Wrapper = styled.div`
  width: 25%;
  padding: 20px;
  background-color: white;

  @media only screen and (max-width: 768px) {
    width: 90%;
    max-width: 400px;
    padding: 20px 18px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  }
`;

const Title = styled.h1`
  font-size: 24px;
  font-weight: 300;

  @media only screen and (max-width: 768px) {
    font-size: 20px;
    text-align: center;
    margin-bottom: 10px;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
`;

const Input = styled.input`
  flex: 1;
  min-width: 40%;
  margin: 10px 0;
  padding: 10px;

  @media only screen and (max-width: 768px) {
    font-size: 16px; /* prevent iOS auto-zoom on focus */
    padding: 12px;
  }
`;

const Button = styled.button`
  width: 40%;
  border: none;
  padding: 15px 20px;
  background-color: teal;
  color: white;
  cursor: pointer;
  margin-bottom: 10px;

  @media only screen and (max-width: 768px) {
    width: 100%;
    padding: 14px 20px;
    font-size: 16px;
    border-radius: 6px;
  }
`;

const Link = styled.a`
  margin: 5px 0px;
  font-size: 12px;
  text-decoration: underline;
  cursor: pointer;

  @media only screen and (max-width: 768px) {
    text-align: center;
    font-size: 13px;
    padding: 6px 0;
  }
`;

const LoginPage = () => {
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });

  useEffect(() => {
    document.title = "Login Page";
  }, []);

  const handleChange = (e) => {
    setCredentials((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/auth/login", credentials);
      const { token, user } = res.data;

      localStorage.setItem("token", token);
      localStorage.setItem("user", JSON.stringify(user));

      alert("Login successful!");
      navigate("/");
    } catch (err) {
      console.error(err);
      alert("Login failed.");
    }
  };

  return (
    <Container>
      <Wrapper>
        <Title>SIGN IN</Title>

        <Form onSubmit={handleLogin}>
          <Input
            name="email"
            placeholder="Email"
            onChange={handleChange}
            required
          />

          <Input
            name="password"
            type="password"
            placeholder="Password"
            onChange={handleChange}
            required
          />
          <Button type="submit">LOGIN</Button>
          <Link>DO NOT YOU REMEMBER THE PASSWORD?</Link>
          <Link onClick={() => navigate("/register")}>
            CREATE A NEW ACCOUNT
          </Link>
        </Form>
      </Wrapper>
    </Container>
  );
};

export default LoginPage;
